import { IQAEnvironmentPopUpBlockerService } from './qa-environment-pop-up-blocker/qa-environment-pop-up-blocker.service.interface';
import { QAEnvironmentPopUpBlockerService } from './qa-environment-pop-up-blocker/qa-environment-pop-up-blocker.service';
import { LiveStreamPlayingService } from './video-live-stream/live-stream-playing.service';
import { IVideoPlayingService } from './video-live-stream/video-playing.service.interface';
import {ITranslationService} from './translation/translation.service.interface';
import {TranslationService} from './translation/translation.service';
import {IRunningGameService} from './running-game/running-game.service.interface';
import {IGamesService} from './games/games.service.interface';
import {ILoggerService} from './logger/logger.service.interface';
import {ICurrencyService} from './currency/currency.service.interface';
import {CurrencyService} from './currency/currency.service';
import {IAnalyticsService} from './analytics/analytics.service.interface';
import {AnalyticsService} from './analytics/analytics.service';
import {ILobbyGameInfoPreviewService} from './lobby-game-info-preview/lobby-game-info-preview.service.interface';
import {LobbyGameInfoPreviewService} from './lobby-game-info-preview/lobby-game-info-preview.service';
import {RunningGameService} from './running-game/running-game.service';
import {GamesService} from './games/games.service';
import {IConfigurationService} from './configurations/configuration.service.interface';
import {ConfigurationsService} from './configurations/configurations.service';
import {Lazy} from '../../utils/Lazy';
import {IUserService} from './user/user.service.interface';
import {UserService} from './user/user.service';
import {IBrowserButtonsHandlerService} from "./browser-buttons-handler/broswer-buttons-handler.service.interface";
import {BrowserButtonsHandlerService} from "./browser-buttons-handler/browser-buttons-handler.service";
import {ISegmentationAggregatorService} from './segmentation-aggregator/segmentation-aggregator.service.interface';
import {SegmentationAggregatorService} from './segmentation-aggregator/segmentation-aggregator.service';
import {ILauncherService} from './launcher/launcher.service.interface';
import {IClientDeviceService} from './client-device/client-device.service.interface';
import {ClientDeviceService} from './client-device/client-device.service';
import {IDeviceService} from './device/device.service.interface';
import {DeviceService} from './device/device.service';
import {IWindowService} from './window/window.service.interface';
import {IAiEngineService} from './ai-engine/ai-engine.service.interface';
import {AiEngineService} from './ai-engine/ai-engine.service';
import {IHttpService} from './http/http.service.interface';
import {IDeepLinkService} from './deep-link/deep-link.service.interface';
import {DeepLinkService} from './deep-link/deep-link.service';
import {ISdkService} from './sdk/sdk.service.interface';
import {SdkService} from './sdk/sdk.service';
import {IServiceFactoryExtended} from './service-factory-extended.interface';
import {IGamesFilterService} from './games-filter/games-filter.service.interface';
import {GamesFilterService} from './games-filter/games-filter.service';
import {IUserMenuService} from "./user-menu/user-menu.service.interface";
import {UserMenuService} from "./user-menu/user-menu.service";
import {IArenasService} from './arenas/arenas.service.interface';
import {ArenasService} from './arenas/arenas.service';
import {IDomService} from './dom/dom.service.interface';
import {ISiteMapService} from './sitemap/sitemap.service.interface';
import {SiteMapService} from './sitemap/sitemap.service';
import {IMarketingService} from './marketing/marketing.service.interface';
import {MarketingService} from './marketing/marketing.service';
import {ILanguageData, ILanguageService} from './language/language.service.interface';
import {LanguageService} from './language/language.service';
import {ISideMenuService} from './side-menu/side-menu.service.interface';
import {SideMenuService} from './side-menu/side-menu.service';
import {IGameSearchService} from './game-search/game-search.service.interface';
import {GameSearchService} from './game-search/game-search.service';
import {IExternalLinksService} from './external-links/external-links.service.interface';
import {ExternalLinksService} from './external-links/external-links.service';
import {ICmsApiService} from './cms/cms-api/cms-api.service.interface';
import {CmsApiService} from './cms/cms-api/cms-api.service';
import {ICmsBannersService} from './cms/cms-banners/cms-banners.service.interface';
import {CmsBannersService} from './cms/cms-banners/cms-banners.service';
import {IStorageService} from './storage/storage.service.interface';
import {ICmsPagesService} from './cms/cms-pages/cms-pages.service.interface';
import {CmsPagesService} from './cms/cms-pages/cms-pages.service';
import {ICmsSegmentationService} from './cms/cms-segmentation/cms-segmentation.service.interface';
import {CmsSegmentationService} from './cms/cms-segmentation/cms-segmentation.service';
import {IDeepLinkActionsFactoryService} from './deep-link/deep-link-action-factory/deep-link-actions-factory.service.inteface';
import {DeepLinkActionsFactoryService} from './deep-link/deep-link-action-factory/deep-link-actions-factory.service';
import {IDeepLinkParserService} from './deep-link/deep-link-parsers/deep-link-parser.service.interface';
import {DeepLinkParserService} from './deep-link/deep-link-parsers/deep-link-parser.service';
import {ISdkComponentFactoryService} from './sdk-component-factory/sdk-component-factory.service.interface';
import {SdkComponentFactoryService} from './sdk-component-factory/sdk-component-factory.service';
import {IStickyHandlerFactoryService} from "./sticky-handler-factory/sticky-handler-factory.service.interface";
import {StickyHandlerFactoryService} from "./sticky-handler-factory/sticky-handler-factory.service";
import {IGamePreviewFeaturesSelectorService} from './game-preview-features-selector/game-preview-features-selector.service.interface';
import {GamePreviewFeaturesSelectorService} from './game-preview-features-selector/game-preview-features-selector.service';
import {GameRouteHandlerService} from './game-route-handler/game-route-handler.service';
import {LauncherService} from './launcher/launcher.service';
import {SpinnerService} from './spinner/spinner.service';
import {ISpinnerService} from './spinner/spinner.service.interface';
import {IMenuFlowService} from "./menu-flow/menu-flow.service.interface";
import {MenuFlowService} from "./menu-flow/menu-flow.service";
import {PokerIntegrationService} from './poker-integration/poker-integration.service';
import {ILocationService} from './location/location.service.interface';
import {LocationService} from './location/location.service';
import {IRoutingConfigurationService} from './routing-configuration/routing-configuration.service.interface';
import {RoutingConfigurationService} from './routing-configuration/routing-configuration.service';
import {IRoutingService} from './routing/routing.service.interface';
import {RoutingService} from './routing/routing.service';
import {IOverlayService} from './overlay/overlay.service.interface';
import {OverlayService} from './overlay/overlay.service';
import {ApplicationStartupConfigurations} from '../app-bootstrap/config-interfaces/application-startup.configurations';
import {SplashService} from './splash/splash.service';
import {ISplashService} from './splash/splash-service.interface';
import {ITimeService} from './time/time.service.interface';
import {TimeService} from './time/time.service';
import {IAiNewGamesEngineService} from "./ai-new-games-engine/ai-new-games.service.interface";
import {AiNewGamesEngineService} from "./ai-new-games-engine/ai-new-games.service";
import {IThemeService} from './theme/theme.service.interface';
import {ThemeService} from './theme/theme.service';
import {MiniOrbitService} from './mini-orbit/mini-orbit.service';
import {IMiniOrbitService} from "./mini-orbit/mini-orbit.service.interface";
import {IDialogService} from './dialog/dialog.service.interface';
import {DialogService} from './dialog/dialog.service';
import {IHeaderService} from './header/header.service.interface';
import {HeaderService} from './header/header.service';
import { IProgressiveWebAppService } from './progressive-web-app/progressive-web-app.service.interface';
import { ProgressiveWebAppService } from './progressive-web-app/progressive-web-app.service';
import { IPWAManifestService } from './manifest/pwa-manifest.service.interface';
import { PWAManifestService } from './manifest/pwa-manifest.service';
import {IMiniOrbitCommunicationAdapterFactoryService} from './mini-orbit/adapter-factory/mini-orbit-communication-adapter-factory.service.interface';
import {MiniOrbitCommunicationAdapterFactoryService} from './mini-orbit/adapter-factory/mini-orbit-communication-adapter-factory.service';

import { ILiveTableFeedsService } from './live-table-feeds-service/live-table-feeds.service.interface';
import { LiveTableFeedsService } from './live-table-feeds-service/live-table-feeds.service';
import {IDrawerService} from './drawer/drawer.service.interface';
import {DrawerService} from './drawer/drawer.service';
import { DailyDealService } from './daily-deal/daily-deal.service';
import { IDailyDealService } from './daily-deal/daily-deal.service.interface';
import { IJackpotsWithStateService } from './jackpots-with-state/jackpots-with-state.service.interface';
import { JackpotsWithStateService } from './jackpots-with-state/jackpots-with-state.service';
import { IJackpotsService } from './jackpots/jackpots.service.interface';
import { JackpotsService } from './jackpots/jackpots.service';
import { IAbTestingFeatureDataProviderService } from './ab-testing/ab-testing-feature-data-provider.service.interface';
import { AbTestingFeatureDataProviderService } from './ab-testing/ab-testing-feature-data-provider.service';
import { IGradualIncreaseHelperFactoryService } from './gradual-increase-helper-factory/gradual-increase-helper-factory.service.interface';
import { GradualIncreaseHelperFactoryService } from './gradual-increase-helper-factory/gradual-increase-helper-factory.service';
import {ISafezoneService} from "./safezone/safezone.service.interface";
import {SafezoneService} from "./safezone/safezone.service";
import {ISafezoneObjectFactoryService} from "./safezone/safezone-object-factory.service.interface";
import {SafezoneObjectFactoryService} from "./safezone/safezone-object-factory.service";
import { IWalletProxyService } from './wallet-proxy/wallet-proxy.service.interface';
import { WalletProxyService } from './wallet-proxy/wallet-proxy.service';
import { SdkHooksProvider } from '../app-bootstrap/sdk-initializer/sdk-hooks-provider';
import {GamePopupService} from "./game-popup/game-popup.service";
import {IGamePopupService} from "./game-popup/game-popup.service.interface";
import {IHomepageService} from "./homepage/homepage.service.interface";
import {HomepageService} from "./homepage/homepage.service";
import {IAnalyticsDataLayerService} from "./analytics/analytics-data-layer.service.interface";
import {AnalyticsDataLayerService} from "./analytics/analytics-data-layer.service";
import {SessionColldownService} from "./session-cooldown/session-cooldown.service";
import {ISessionCooldownService} from "./session-cooldown/session-cooldown.service.interface";
import { IMediaChecks } from './media-query/media-queries.interface';
import { MediaQueryService } from './media-query/media-query.service';

import { OrbitApi } from '../orbit-api';
import {IToolsService} from "./tools/tools.service.interface";
import {ToolsService} from "./tools/tools.service";
import {VerticalGamesListService} from "./vertical-games-list/vertical-games-list.service";
import {IVerticalGamesListService} from "./vertical-games-list/vertical-games-list.service.interface";
import {IUserGameOrientationService} from "./user-game-orientation/user-game-orientation.service.interface";
import {UserGameOrientationService} from "./user-game-orientation/user-game-orientation.service";
import {ApiService} from './api/api.service';

import {OrbitComponentToSdkAdapterService} from './orbit-component-to-sdk-adapter/orbit-component-to-sdk-adapter.service';
import {IOrbitComponentsInsideSdkProvider} from './orbit-component-to-sdk-adapter/orbit-components-inside-sdk-provider.interface';
import { IOmgService } from './omg-proxy/omg.service.interface';
import { OmgService } from './omg-proxy/omg.service';
import {IMessageBrokerService} from './casinofied/message-broker/message-broker.service.interface';
import {MessageBrokerService} from './casinofied/message-broker/message-broker.service';
import {ICasinofiedAppLauncherService} from './casinofied/app-launcher/casinofied-app-launcher.service.interface';
import {CasinofiedAppLauncherService} from './casinofied/app-launcher/casinofied-app-launcher.service';
import {CasinofiedActionHandlerService} from './casinofied/action-handler/casinofied-action-handler.service';
import {IFloatingBubblesService} from './floating-bubbles/floating-bubbles.service.interface';
import {FloatingBubblesService} from './floating-bubbles/floating-bubbles.service';
import {IRestrictionRulerService} from "./restriction-ruler/restriction-ruler.service.interface";
import {RestrictionRulerService} from "./restriction-ruler/restriction-ruler.service";
import { IRedTigerService } from './red-tiger/red-tiger.service.interface';
import { RedTigerService } from './red-tiger/red-tiger.service';
import {CasinofiedAnalyticsService} from './casinofied/analytics-publisher/casinofied-analytics.service';
import { HttpWithRequestTimeMeasurement } from './http/http-with-request-time-measurement.service';
import { HttpService } from './http/http.service';
import {IAbTestingAiSortGamesListsService} from "./ab-testing-ai-sort/ab-testing-ai-sort-games-lists.service.interface";
import {AbTestingAiSortGamesListsService} from "./ab-testing-ai-sort/ab-testing-ai-sort-games-lists.service";
import {ICashierService} from "../../common/interfaces/cashier.service.interface";
import {CashierService} from "./cashier/cashier.service";
import { IRegulationService } from './regulation/regulation.service.interface';
import { RegulationService } from './regulation/regulation.service';
import {LimitsToasterService} from './limits-toaster/limits-toaster.service';
import { PlayerBurnoutService } from './burnout/player-burnout.service';
import { IPlayerBurnoutService } from './burnout/player-burnout.service.interface';
import { IPlayerOfferingsService } from './player-offerings/player-offerings.service.interface';
import { PlayerOfferingsService } from './player-offerings/player-offerings.service';
import { PixiAppService } from './pixi-app/pixi-app.service';
import { IPixiAppService } from './pixi-app/pixi-app.service.interface';
import { IGameAnimatedIconsManagerService } from './game-animated-icons-manager/game-animated-icons-manager.service.interface';
import { GameAnimatedIconsManagerService } from './game-animated-icons-manager/game-animated-icons-manager.service';
import { IWebGLContextManagerService } from './webgl-context-manager/webgl-context-manager.service.interface';
import { WebGLContextManagerService } from './webgl-context-manager/webgl-context-manager.service';
import {ExitPopupService} from "./exit-popup/exit-popup.service";
import {IExitPopupService} from "./exit-popup/exit-popup.service.interface";
import {ITooltipService} from "./tooltip/tooltip.service.interface";
import {TooltipService} from "./tooltip/tooltip.service";
import {GamingHistoryService} from "./gaming-history/gaming-history.service";
import {IGamingHistoryService} from "./gaming-history/gaming-history.service.interfce";
import {ICompaniesService} from "./companies/companies.service.interface";
import {CompaniesService} from "./companies/companies.service";
import { IBecauseYouPlayedService } from './because-you-played/because-you-played.service.interface';
import { BecauseYouPlayedService } from './because-you-played/because-you-played.service';
import {GameRunnerService} from "./game-runner/game-runner.service";
import {IGameRunnerService} from "./game-runner/game-runner.service.interface";
import {IHybridService} from "./hybrid/hybrid.service.interface";
import {HybridService} from "./hybrid/hybrid.service";
import {StaticVideoPlayingService} from "./video-live-stream/static-video-playing.service";
import {SessionStorageService} from "./storage/session-storage.service";
import {ICookiesService} from "./storage/cookies.service.interface";
import {CookiesService} from "./storage/cookies.service";
import {IFreePlayService} from "./free-play/free-play.service.interface";
import {FreePlayService} from "./free-play/free-play.service";
import {IRestrictionsService} from "./restrictions/restrictions.service.interface";
import {RestrictionsService} from "./restrictions/restrictions.service";
import {IFreeToPlayService} from "./free-to-play/free-to-play.service.interface";
import {FreeToPlayService} from "./free-to-play/free-to-play.service";
import {IThemeDefinition} from "./theme/theme-definition.interface";
import {IGnwpService} from "./gnwp/gnwp.service.interface";
import {GnwpService} from "./gnwp/gnwp.service";
import {IScriptLoaderService} from "./scrip-loader/script-loader.service.interface";
import {ScriptLoaderService} from "./scrip-loader/script-loader.service";
import {IAdminBannerService} from "./admin-banner/admin-banner-service.interface";
import {AdminBannerService} from "./admin-banner/admin-banner.service";
import {ISessionTimerService} from "./session-timer/session-timer.service.interface";
import {SessionTimerService} from "./session-timer/session-timer.service";
import {ICasinofiedAnalyticsService} from "../../common/interfaces/casinofied-analytics-proxy.interface";
import {IGeoLocationService} from "./geo-location/geo-location.service.interface";
import {GeoLocationService} from "./geo-location/geo-location.service";
import { ICrmService } from './crm/crm.service.interface';
import { CrmService } from './crm/crm.service';
import {ISpecificDialogsService} from './specific-dialogs/specific-dialogs.service.interface';
import {SpecificDialogsService} from './specific-dialogs/specific-dialogs.service';
import {ITippingHistoryService} from './tipping-history/tipping-history.service.interface';
import {TippingHistoryService} from './tipping-history/tipping-history.service';
import {LoyaltyService} from './loyalty-indicator/loyalty-indicator.service';
import {ILoyaltyService} from './loyalty-indicator/loyalty-indicator.service.interface';
import {StateOfResidenceIdentifierService} from "./state-of-residence-identifier/state-of-residence-identifier.service";
import {IStateOfResidenceIdentifier} from "./state-of-residence-identifier/state-of-residence-identifier.interface";
import {ILoginPopupService} from "./login-popup/login-popup.service.interface";
import {LoginPopupService} from "./login-popup/login-popup.service";

export class ServiceFactory implements IServiceFactoryExtended {
    readonly splash: ISplashService;
    readonly logger: ILoggerService;
    readonly localStorage: IStorageService;
    readonly window: IWindowService;
    readonly dom: IDomService;
    readonly http: IHttpService;
    readonly sdkHooksProvider: SdkHooksProvider;

    constructor(sdkHooksProvider: SdkHooksProvider,
                logger: ILoggerService,
                localStorage: IStorageService,
                windowService: IWindowService,
                domService: IDomService,
                httpService: IHttpService,
                themeDefinition: IThemeDefinition,
                private _appStartupConfigs: ApplicationStartupConfigurations,
                private _languageData: ILanguageData) {

        window['orbit'] = new OrbitApi(this);
        sdkHooksProvider.services = this;

        this.logger = logger;
        this.splash = new SplashService();
        this.localStorage = localStorage;
        this.window = windowService;
        this.dom = domService;
        this.http = httpService;
        this._themeDefinition = themeDefinition;

        this._sdk.forceInit();
        this._configuration.forceInit();
        this._userService.forceInit();
        this._spinner.forceInit();
        this._location.forceInit();
        this._routing.forceInit();
        this._segmentation.forceInit();

        this._deepLink.forceInit();

        this._cmsPages.forceInit();
        this._marketing.forceInit();

        this._siteMap.forceInit();
        this._games.forceInit();

        this._gamesFilter.forceInit();

        this._gameRouteHandler.forceInit();

        this._aiEngine.forceInit();
        this._aiNewEngine.forceInit();

        this._lobbyGameInfoPreview.forceInit();

        this._pokerIntegration.forceInit();
        this._userMenu.forceInit();
        this._externalLinks.forceInit();
        this._theme.forceInit();
        this._miniOrbit.forceInit();
        this._pwaManifest.forceInit();
        this._progressiveWebApp.forceInit();
        this._drawerService.forceInit();
        this._safezone.forceInit();
        this._gamePopup.forceInit();
        this._homepageService.forceInit();
        this._jackpots.forceInit();
        this._jackpotsWithState.forceInit();
        this._sessionCooldown.forceInit();
        this._userGameOrientationService.forceInit();
        this._browserButtonsHandler.forceInit();

        this._appLauncher.forceInit();
        this._actionHandler.forceInit();
        this._restrictionRuler.forceInit();
        this._httpWithRequestTimeMeasurement.forceInit();
        this._casinofiedAnalytics.forceInit();
        this._limitsToaster.forceInit();
        this._exitPopup.forceInit();

        this._sideMenu.forceInit();
        this._toolTip.forceInit();
        this._gameSearch.forceInit();
        this._gameRunner.forceInit();
        this._freePlay.forceInit();
        this._adminBanner.forceInit();
        this._sessionTimer.forceInit();

        this._crm.forceInit();

        this._stateOfResidenceIdentifier.forceInit();
        this._loginPopup.forceInit();
        this._omg.forceInit();

        this.sdk.fireOrbitInitComplete();
    }

    private _externalLinks = new Lazy<IExternalLinksService>(() => new ExternalLinksService(this));
    public get externalLinks(): IExternalLinksService {
        return this._externalLinks.value;
    }

    private _userMenu = new Lazy<IUserMenuService>(() => new UserMenuService(this));
    public get userMenu(): IUserMenuService {
        return this._userMenu.value;
    }

    private _pokerIntegration = new Lazy<PokerIntegrationService>(() => new PokerIntegrationService(this));
    public get pokerIntegration(): PokerIntegrationService {
        return this._pokerIntegration.value;
    }

    private _verticalGamesList = new Lazy<IVerticalGamesListService>(() => new VerticalGamesListService(this));
    public get verticalGamesList(): IVerticalGamesListService {
        return this._verticalGamesList.value;
    }

    private _lobbyGameInfoPreview = new Lazy<ILobbyGameInfoPreviewService>(() => new LobbyGameInfoPreviewService(this));
    public get lobbyGameInfoPreview(): ILobbyGameInfoPreviewService {
        return this._lobbyGameInfoPreview.value;
    }

    private _aiEngine = new Lazy<IAiEngineService>(() => new AiEngineService(this));
    public get aiEngine(): IAiEngineService {
        return this._aiEngine.value;
    }

    private _aiNewEngine = new Lazy<IAiNewGamesEngineService>(() => new AiNewGamesEngineService(this));
    public get aiNewEngine(): IAiNewGamesEngineService {
        return this._aiNewEngine.value;
    }

    private _deepLink = new Lazy<IDeepLinkService>(() => new DeepLinkService(this));
    public get deepLink(): IDeepLinkService {
        return this._deepLink.value;
    }

    private _gameRouteHandler = new Lazy<GameRouteHandlerService>(() => new GameRouteHandlerService(this));
    public get gameRouteHandler(): GameRouteHandlerService {
        return this._gameRouteHandler.value;
    }

    private _gamesFilter = new Lazy<IGamesFilterService>(() => new GamesFilterService(this));
    public get gamesFilter(): IGamesFilterService {
        return this._gamesFilter.value;
    }

    private _runningGame = new Lazy<IRunningGameService>(() => new RunningGameService(this));
    public get runningGame(): IRunningGameService {
        return this._runningGame.value;
    }

    private _becauseYouPlayed = new Lazy<IBecauseYouPlayedService>(() => new BecauseYouPlayedService(this));
    public get becauseYouPlayed(): IBecauseYouPlayedService {
        return this._becauseYouPlayed.value;
    }

    private _games = new Lazy<IGamesService>(() => new GamesService(this));
    public get games(): IGamesService {
        return this._games.value;
    }

    private _siteMap = new Lazy<ISiteMapService>(() => new SiteMapService(this));
    public get siteMap(): ISiteMapService {
        return this._siteMap.value;
    }

    private _marketing = new Lazy<IMarketingService>(() => new MarketingService(this));
    public get marketing(): IMarketingService {
        return this._marketing.value;
    }

    private _cmsPages = new Lazy<ICmsPagesService>(() => new CmsPagesService(this));
    public get cmsPages(): ICmsPagesService {
        return this._cmsPages.value;
    }

    private _configuration = new Lazy<IConfigurationService>(() => new ConfigurationsService(this, this._appStartupConfigs));
    public get configuration(): IConfigurationService {
        return this._configuration.value;
    }

    private _spinner = new Lazy<ISpinnerService>(() => new SpinnerService(this));
    public get spinner(): ISpinnerService {
        return this._spinner.value;
    }

    private _location = new Lazy<ILocationService>(() => new LocationService(window, this.localStorage, (action: string, label?: string, value?: any) => this.analytics.sendTechnicalEvent(action, label, value)));
    public get location(): ILocationService {
        return this._location.value;
    }

    private _routing = new Lazy<IRoutingService>(() => new RoutingService(this));
    public get routing(): IRoutingService {
        return this._routing.value;
    }

    private _regulation = new Lazy<IRegulationService>(() => new RegulationService(this));
    public get regulation(): IRegulationService {
        return this._regulation.value;
    }

    private _segmentation = new Lazy<ISegmentationAggregatorService>(() => new SegmentationAggregatorService(this));
    public get segmentation(): ISegmentationAggregatorService {
        return this._segmentation.value;
    }

    private _liveTableFeeds = new Lazy<ILiveTableFeedsService>(() => new LiveTableFeedsService(this));
    public get liveTableFeeds(): ILiveTableFeedsService {
        return this._liveTableFeeds.value;
    }

    private _translation = new Lazy<ITranslationService>(() => new TranslationService(this));
    public get translation(): ITranslationService {
        return this._translation.value;
    }

    private _currencyService = new Lazy<ICurrencyService>(() => new CurrencyService(this));

    public get currency(): ICurrencyService {
        return this._currencyService.value;
    }

    private _analyticsService = new Lazy<IAnalyticsService>(() => new AnalyticsService(this));

    public get analytics(): IAnalyticsService {
        return this._analyticsService.value;
    }

    private _analyticsDataLayerService = new Lazy<IAnalyticsDataLayerService>(() => new AnalyticsDataLayerService(this));

    public get analyticsDataLayer(): IAnalyticsDataLayerService {
        return this._analyticsDataLayerService.value;
    }

    private _userService = new Lazy<IUserService>(() => new UserService(this));

    get user(): IUserService {
        return this._userService.value;
    }

    private _browserButtonsHandler = new Lazy<IBrowserButtonsHandlerService>(() => new BrowserButtonsHandlerService(this));
    get browserButtonsHandler(): IBrowserButtonsHandlerService {
        return this._browserButtonsHandler.value;
    }

    private _homepageService = new Lazy<IHomepageService>(() => new HomepageService(this));

    get homepage(): IHomepageService {
        return this._homepageService.value;
    }

    private _userGameOrientationService = new Lazy<IUserGameOrientationService>(() => new UserGameOrientationService(this));

    get userGameOrientation(): IUserGameOrientationService {
        return this._userGameOrientationService.value;
    }

    private _cmsApi = new Lazy<ICmsApiService>(() => new CmsApiService(this));
    get cmsApi(): ICmsApiService {
        return this._cmsApi.value;
    }

    private _cmsBanners = new Lazy<ICmsBannersService>(() => new CmsBannersService(this));
    get cmsBanners(): ICmsBannersService {
        return this._cmsBanners.value;
    }

    private _launcher = new Lazy<ILauncherService>(() => new LauncherService(this));
    get launcher(): ILauncherService {
        return this._launcher.value;
    }

    private _clientDevice = new Lazy<IClientDeviceService>(() => new ClientDeviceService(this));
    get clientDevice(): IClientDeviceService {
        return this._clientDevice.value;
    }

    private _device = new Lazy<IDeviceService>(() => new DeviceService(this));
    get device(): IDeviceService {
        return this._device.value;
    }

    private _deepLinkParser = new Lazy<IDeepLinkParserService>(() => new DeepLinkParserService(this));
    get deepLinkParser(): IDeepLinkParserService {
        return this._deepLinkParser.value;
    }

    private _deepLinkActionsFactory = new Lazy<IDeepLinkActionsFactoryService>(() => new DeepLinkActionsFactoryService(this));
    get deepLinkActionsFactory(): IDeepLinkActionsFactoryService {
        return this._deepLinkActionsFactory.value;
    }

    private _sdk: Lazy<ISdkService> = new Lazy<ISdkService>(() => new SdkService(this));
    get sdk(): ISdkService {
        return this._sdk.value;
    }

    private _arenas = new Lazy<IArenasService>(() => new ArenasService(this));
    get arenas(): IArenasService {
        return this._arenas.value;
    }

    private _language = new Lazy<ILanguageService>(() => new LanguageService(this._languageData, this));
    get language(): ILanguageService {
        return this._language.value;
    }

    private _sideMenu = new Lazy<ISideMenuService>(() => new SideMenuService(this));
    get sideMenu(): ISideMenuService {
        return this._sideMenu.value;
    }

    private _gameSearch = new Lazy<IGameSearchService>(() => new GameSearchService(this));
    get gameSearch(): IGameSearchService {
        return this._gameSearch.value;
    }

    private _gamePopup = new Lazy<IGamePopupService>(() => new GamePopupService(this));
    get gamePopup(): IGamePopupService {
        return this._gamePopup.value;
    }


    private _cmsSegmentation = new Lazy<ICmsSegmentationService>(() => new CmsSegmentationService(this));
    get cmsSegmentation(): ICmsSegmentationService {
        return this._cmsSegmentation.value;
    }

    private _stickyHandlerFactory = new Lazy<IStickyHandlerFactoryService>(() => new StickyHandlerFactoryService(this));
    get stickyHandlerFactory(): IStickyHandlerFactoryService {
        return this._stickyHandlerFactory.value;
    }

    private _menuFlow = new Lazy<IMenuFlowService>(() => new MenuFlowService(this));
    get menuFlow(): IMenuFlowService {
        return this._menuFlow.value;
    }

    private _exitPopup = new Lazy<IExitPopupService>(() => new ExitPopupService(this));
    get exitPopup(): IExitPopupService {
        return this._exitPopup.value;
    }

    private _sdkComponentFactory = new Lazy<ISdkComponentFactoryService>(() => new SdkComponentFactoryService(this));
    get sdkComponentFactory(): ISdkComponentFactoryService {
        return this._sdkComponentFactory.value;
    }

    private _gamePreviewFeaturesSelector = new Lazy<IGamePreviewFeaturesSelectorService>(() => new GamePreviewFeaturesSelectorService(this));
    get gamePreviewFeaturesSelector(): IGamePreviewFeaturesSelectorService {
        return this._gamePreviewFeaturesSelector.value;
    }

    private _routingConfiguration = new Lazy<IRoutingConfigurationService>(() => new RoutingConfigurationService(this));
    get routingConfiguration(): IRoutingConfigurationService {
        return this._routingConfiguration.value;
    }

    private _overlay = new Lazy<IOverlayService>(() => new OverlayService(this));
    get overlay(): IOverlayService {
        return this._overlay.value;
    }

    private _time = new Lazy<ITimeService>(() => new TimeService(this));
    get time(): ITimeService {
        return this._time.value;
    }

    private _abTestingFeatureDataProvider = new Lazy<IAbTestingFeatureDataProviderService>(() => new AbTestingFeatureDataProviderService(this));
    get abTestingFeatureDataProvider(): IAbTestingFeatureDataProviderService {
        return this._abTestingFeatureDataProvider.value;
    }

    private _abTestingAiSort = new Lazy<IAbTestingAiSortGamesListsService>(() => new AbTestingAiSortGamesListsService(this));

    get abTestingAiSortGamesLists(): IAbTestingAiSortGamesListsService {
        return this._abTestingAiSort.value;
    }


    private readonly _themeDefinition: IThemeDefinition = null!;
    private _theme = new Lazy<IThemeService>(() => new ThemeService(this, this._themeDefinition));
    get theme(): IThemeService {
        return this._theme.value;
    }

    private _miniOrbit = new Lazy<IMiniOrbitService>(() => new MiniOrbitService(this));
    public get miniOrbit(): IMiniOrbitService {
        return this._miniOrbit.value;
    }

    private _dialog = new Lazy<IDialogService>(() => new DialogService(this));
    public get dialog(): IDialogService {
        return this._dialog.value;
    }

    private _header = new Lazy<IHeaderService>(() => new HeaderService(this));
    public get header(): IHeaderService {
        return this._header.value;
    }

    private _pwaManifest = new Lazy<IPWAManifestService>(() => new PWAManifestService(this));
    public get manifest(): IPWAManifestService {
        return this._pwaManifest.value;
    }

    private _progressiveWebApp = new Lazy<IProgressiveWebAppService>(() => new ProgressiveWebAppService(this));
    public get progressiveWebApp(): IProgressiveWebAppService {
        return this._progressiveWebApp.value;
    }

    private _miniOrbitCommunicationAdapterFactory = new Lazy<IMiniOrbitCommunicationAdapterFactoryService>(() => new MiniOrbitCommunicationAdapterFactoryService(this));
    public get miniOrbitCommunicationAdapterFactory(): IMiniOrbitCommunicationAdapterFactoryService {
        return this._miniOrbitCommunicationAdapterFactory.value;
    }

    private _drawerService = new Lazy<IDrawerService>(() => new DrawerService(this));

    public get drawer(): IDrawerService {
        return this._drawerService.value;
    }

    private _dailyDeal = new Lazy<IDailyDealService>(() => new DailyDealService(this));
    public get dailyDeal(): IDailyDealService {
        return this._dailyDeal.value;
    }

    private _omg = new Lazy<IOmgService>(() => new OmgService(this));
    public get omg(): IOmgService {
        return this._omg.value;
    }

    private _jackpotsWithState = new Lazy<IJackpotsWithStateService>(() => new JackpotsWithStateService(this),);
    public get jackpotsWithState(): IJackpotsWithStateService {
        return this._jackpotsWithState.value;
    }

    private _jackpots = new Lazy<IJackpotsService>(() => new JackpotsService(this),);
    public get jackpots(): IJackpotsService {
        return this._jackpots.value;
    }

    private _gradualIncreaseHelperFactory = new Lazy<IGradualIncreaseHelperFactoryService>(() => new GradualIncreaseHelperFactoryService(this));
    public get gradualIncreaseHelperFactory(): IGradualIncreaseHelperFactoryService {
        return this._gradualIncreaseHelperFactory.value;
    }

    private _walletProxy = new Lazy<IWalletProxyService>(() => new WalletProxyService(this));
    public get walletProxy(): IWalletProxyService {
        return this._walletProxy.value;
    }

    private _safezone = new Lazy<ISafezoneService>(() => new SafezoneService(this));
    public get safezone(): ISafezoneService {
        return this._safezone.value;
    }

    private _safezoneObjectFactory = new Lazy<ISafezoneObjectFactoryService>(() => new SafezoneObjectFactoryService(this));
    public get safezoneObjectFactory(): ISafezoneObjectFactoryService {
        return this._safezoneObjectFactory.value;
    }

    private _tools = new Lazy<IToolsService>(() => new ToolsService(this));
    public get tools(): IToolsService {
        return this._tools.value;
    }

    private _sessionCooldown = new Lazy<ISessionCooldownService>(() => new SessionColldownService(this));
    public get sessionCooldown(): ISessionCooldownService {
        return this._sessionCooldown.value;
    }

    private _mediaQuery = new Lazy<IMediaChecks>(() => new MediaQueryService(this));
    public get mediaQuery(): IMediaChecks {
        return this._mediaQuery.value;
    }

    private _api = new Lazy<ApiService>(() => new ApiService(this));
    public get api(): ApiService {
        return this._api.value;
    }

    private _orbitComponentToSdkAdapter = new Lazy<IOrbitComponentsInsideSdkProvider>(() => new OrbitComponentToSdkAdapterService(this));

    public get orbitComponentInsideSdkProvider(): IOrbitComponentsInsideSdkProvider {
        return this._orbitComponentToSdkAdapter.value;
    }

    private _messageBroker = new Lazy<IMessageBrokerService>(() => new MessageBrokerService(this));
    public get messageBroker(): IMessageBrokerService {
        return this._messageBroker.value;
    }

    private _appLauncher = new Lazy<ICasinofiedAppLauncherService>(() => new CasinofiedAppLauncherService(this));
    public get appLauncher(): ICasinofiedAppLauncherService {
        return this._appLauncher.value;
    }

    // No need to expose this service as public member. It is not consumed by any other service or component
    private _actionHandler = new Lazy<CasinofiedActionHandlerService>(() => new CasinofiedActionHandlerService(this));

    private _floatingBubbles = new Lazy<IFloatingBubblesService>(() => new FloatingBubblesService(this));
    public get floatingBubbles(): IFloatingBubblesService {
        return this._floatingBubbles.value;
    }

    private _restrictionRuler = new Lazy<IRestrictionRulerService>(() => new RestrictionRulerService(this));
    public get restrictionRuler(): IRestrictionRulerService {
        return this._restrictionRuler.value;
    }

    private _redTiger = new Lazy<IRedTigerService>(() => new RedTigerService(this));
    public get redTiger(): IRedTigerService {
        return this._redTiger.value;
    }

    private _casinofiedAnalytics = new Lazy<ICasinofiedAnalyticsService>(() => new CasinofiedAnalyticsService(this));
    public get casinofiedAnalytics(): ICasinofiedAnalyticsService {
        return this._casinofiedAnalytics.value;
    }

    private _liveStreamPlaying = new Lazy<IVideoPlayingService>(() => new LiveStreamPlayingService(this));
    public get liveStreamPlaying(): IVideoPlayingService {
        return this._liveStreamPlaying.value;
    }

    private _staticVideoPlaying = new Lazy<IVideoPlayingService>(() => new StaticVideoPlayingService(this));
    public get staticVideoPlaying(): IVideoPlayingService {
        return this._staticVideoPlaying.value;
    }

    private _httpWithRequestTimeMeasurement: Lazy<IHttpService> = new Lazy<IHttpService>(() => new HttpWithRequestTimeMeasurement(this, this.http as HttpService));
    get httpWithRequestTimeMeasurement(): IHttpService {
        return this._httpWithRequestTimeMeasurement.value;
    }

    private _cashier: Lazy<ICashierService> = new Lazy<ICashierService>(() => new CashierService(this));
    get cashier(): ICashierService {
        return this._cashier.value;
    }

    private _playerOfferings: Lazy<IPlayerOfferingsService> = new Lazy<IPlayerOfferingsService>(() => new PlayerOfferingsService(this));
    get playerOfferings(): IPlayerOfferingsService {
        return this._playerOfferings.value;
    }

    private _qaEnvironmentPopUpBlockerService = new Lazy<IQAEnvironmentPopUpBlockerService>(() => new QAEnvironmentPopUpBlockerService(this));
    public get qaEnvironmentPopUpBlockerService(): IQAEnvironmentPopUpBlockerService {
        return this._qaEnvironmentPopUpBlockerService.value;
    }

    private _limitsToaster = new Lazy<LimitsToasterService>(() => new LimitsToasterService(this));
    public get limitsToaster(): LimitsToasterService {
        return this._limitsToaster.value;
    }

    private _burnoutService = new Lazy<IPlayerBurnoutService>(() => new PlayerBurnoutService(this));
    public get burnoutService(): IPlayerBurnoutService {
        return this._burnoutService.value;
    }

    private _pixiAppService = new Lazy<IPixiAppService>(() => new PixiAppService(this));
    public get pixiApp(): IPixiAppService {
        return this._pixiAppService.value;
    }

    private _gameAnimatedIconsManagerService = new Lazy<IGameAnimatedIconsManagerService>(() => new GameAnimatedIconsManagerService(this));
    public get gameAnimatedIconsManager(): IGameAnimatedIconsManagerService {
        return this._gameAnimatedIconsManagerService.value;
    }

    private _webGlContextManagerService = new Lazy<IWebGLContextManagerService>(() => new WebGLContextManagerService(this));
    public get webGlContextManager(): IWebGLContextManagerService {
        return this._webGlContextManagerService.value;
    }

    private _toolTip = new Lazy<ITooltipService>(() => new TooltipService(this));
    public get tooltip(): ITooltipService {
        return this._toolTip.value;
    }

    private _gamingHistory = new Lazy<IGamingHistoryService>(() => new GamingHistoryService(this));
    public get gamingHistory(): IGamingHistoryService {
        return this._gamingHistory.value;
    }

    private _tippingHistory = new Lazy<ITippingHistoryService>(() => new TippingHistoryService(this));
    public get tippingHistory(): ITippingHistoryService {
        return this._tippingHistory.value;
    }

    private _companies = new Lazy<ICompaniesService>(() => new CompaniesService(this));
    public get companies(): ICompaniesService {
        return this._companies.value;
    }

    private _freeToPlayService = new Lazy<IFreeToPlayService>(() => new FreeToPlayService(this));
    public get freeToPlay(): IFreeToPlayService {
        return this._freeToPlayService.value;
    }

    private _gameRunner = new Lazy<IGameRunnerService>(() => new GameRunnerService(this));
    public get gameRunner(): IGameRunnerService {
        return this._gameRunner.value;
    }

    private _hybrid = new Lazy<IHybridService>(() => new HybridService(this));
    public get hybrid(): IHybridService {
        return this._hybrid.value;
    }

    private _sessionStorage = new Lazy<IStorageService>(() => new SessionStorageService(this.logger));
    public get sessionStorage(): IStorageService {
        return this._sessionStorage.value;
    }

    private _cookies = new Lazy<ICookiesService>(() => new CookiesService());
    public get cookies(): ICookiesService {
        return this._cookies.value;
    }

    private _freePlay = new Lazy<IFreePlayService>(() => new FreePlayService(this));
    public get freePlay(): IFreePlayService {
        return this._freePlay.value;
    }

    private _restrictions = new Lazy<IRestrictionsService>(() => new RestrictionsService(this));
    public get restrictions(): IRestrictionsService {
        return this._restrictions.value;
    }

    private _gnwp = new Lazy<IGnwpService>(() => new GnwpService(this));
    public get gnwp(): IGnwpService {
        return this._gnwp.value;
    }

    private _scriptLoader = new Lazy<IScriptLoaderService>(() => new ScriptLoaderService(this));
    public get scriptLoader(): IScriptLoaderService {
        return this._scriptLoader.value;
    }

    private _adminBanner = new Lazy<IAdminBannerService>(() => new AdminBannerService(this));
    get adminBanner(): IAdminBannerService {
        return this._adminBanner.value;
    }

    private _sessionTimer = new Lazy<ISessionTimerService>(() => new SessionTimerService(this));
    get sessionTimer(): ISessionTimerService {
        return this._sessionTimer.value;
    }

    private _geoLocation = new Lazy<IGeoLocationService>(() => new GeoLocationService(this));
    get geoLocation(): IGeoLocationService {
        return this._geoLocation.value;
    }

    private _crm = new Lazy<ICrmService>(() => new CrmService(this));
    get crm(): ICrmService {
        return this._crm.value;
    }

    private _specificDialogs = new Lazy<ISpecificDialogsService>(() => new SpecificDialogsService(this));
    get specificDialogs(): ISpecificDialogsService {
        return this._specificDialogs.value
    }

    private _stateOfResidenceIdentifier = new Lazy<IStateOfResidenceIdentifier>(() => new StateOfResidenceIdentifierService(this));
    get stateOfResidenceIdentifier(): IStateOfResidenceIdentifier {
        return this._stateOfResidenceIdentifier.value;
    }

    private _loyaltyIndicator = new Lazy<ILoyaltyService>(() => new LoyaltyService(this));
    get loyaltyIndicator(): ILoyaltyService {
        return this._loyaltyIndicator.value
    }

    private _loginPopup = new Lazy<ILoginPopupService>(() => new LoginPopupService(this));
    get loginPopup(): ILoginPopupService {
        return this._loginPopup.value;
    }
}